var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactSubPage',{attrs:{"title":{ 'zh-CN': '客户留言', 'en-US': 'Customer Message' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }